import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" RESET ALL FILTERS ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_races_table = _resolveComponent("races-table")!
  const _component_n_pagination = _resolveComponent("n-pagination")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_races_table, {
      onUnenqueue: _ctx.onUnenqueued,
      onJoin: _ctx.onJoined,
      onSearch: _ctx.search,
      raceType: "join",
      races: _ctx.races
    }, null, 8, ["onUnenqueue", "onJoin", "onSearch", "races"]),
    _createVNode(_component_n_space, {
      justify: "center",
      style: {"margin-top":"2.5rem"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_pagination, {
          page: _ctx.page,
          "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageSize) = $event)),
          "item-count": _ctx.totalRaces,
          "show-size-picker": "",
          "page-sizes": [5, 10, 25, 50],
          "page-slot": _ctx.breakpoints.sDown.matches ? 4 : 7,
          style: {"margin-bottom":"1rem"}
        }, null, 8, ["page", "page-size", "item-count", "page-slot"]),
        (_ctx.filtersChanged)
          ? (_openBlock(), _createBlock(_component_n_button, {
              key: 0,
              size: "small",
              type: "error",
              ghost: "",
              onClick: _ctx.resetFilters
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}